/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Модель дополнительных полей поселений
   */
  app.SettlementExt = app.Model.extend({
    urlRoot: app.entryScriptName + '/api/v3/settlement-ext',
    
    idAttribute: 'settlement_id',
    
    url: function () {
      return Backbone.Model.prototype.url.apply(this)
        + '/?expand=deliveryTimeInterval,deliveryConditions,deliveryAddresses,deliveryTimes,deliveryProjects,min_sum_order,deliveryDirection,min_delivery_sum'
        + '&currency=' + app.currentCurrency.name;
    }
  });
})();

}.call(window));